'use strict';

/**
 * Antavo activity grid, client wiring.
 *
 * Loaded globally from main.js, NOT by the grid template: the grid's Page
 * Designer shell is page-cached and a cached component's render script does
 * not re-execute, so an `assets.addJs` inside it never reaches the browser;
 * an AJAX-rendered region includes no scripts at all. Loading here makes the
 * flows work wherever the grid is dropped. The card styles ride along in
 * global.css for the same reason.
 *
 * The grid itself is server-rendered per member via remote include; the
 * browser only handles the in-card flows (opening a survey or quiz,
 * answering, swapping in the next server-rendered fragment).
 *
 * The underscore prefix is mandatory: the builder emits every non-underscore
 * file under client/default/js/ as its own standalone bundle, so without it
 * this module ships twice.
 */

var quiz = require('./activities/_quiz');
var survey = require('./activities/_survey');

module.exports = {
    /**
     * Delegated from `body`, so a grid that arrives later in an AJAX-rendered
     * region is covered without re-initializing.
     */
    loyaltyActivityFlows: function () {
        survey.init();
        quiz.init();
    }
};
